import { useTranslate } from '@tolgee/react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
  PINTEREST,
  PINTEREST_AI_DISCLOSURE_SYNTHETIC_PERFORMER
} from '../../../../config/constants';
import {
  setPostDataAttribute,
  setSliceAttribute
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import CreatorCard from '../commonElements/creatorCard';

const AiGeneratedContentToggle: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const {
    ai_generated_content: aiGeneratedContent,
    has_been_published: hasBeenPublished,
    lomavisCreatorConfig,
    platformEnabled,
    postData
  } = useSelector((state: any) => state.lomavisCreator);

  const title = t(
    'lomavisCreator.aiGeneratedContent.title',
    'Mark as AI-generated'
  );
  const subtitle = t(
    'lomavisCreator.aiGeneratedContent.subtitle',
    'For AI-created images, videos or audio.'
  );
  const rulesLinkLabel = t(
    'lomavisCreator.aiGeneratedContent.rulesPerPlatform',
    'Rules per platform'
  );

  const handleToggle = () => {
    const aiGeneratedContentEnabled = !aiGeneratedContent;

    dispatch(
      setSliceAttribute({
        attribute: 'ai_generated_content',
        value: aiGeneratedContentEnabled
      })
    );

    const pinterestAdditionalPublicationData =
      postData?.[PINTEREST]?.additional_publication_data || {};
    const pinterestAiDisclosure =
      pinterestAdditionalPublicationData?.ai_disclosures?.values?.[0];

    if (
      aiGeneratedContentEnabled &&
      platformEnabled[PINTEREST] &&
      !pinterestAiDisclosure
    ) {
      dispatch(
        setPostDataAttribute({
          platform: PINTEREST,
          attribute: 'additional_publication_data',
          value: {
            ...pinterestAdditionalPublicationData,
            ai_disclosures: {
              values: [PINTEREST_AI_DISCLOSURE_SYNTHETIC_PERFORMER]
            }
          }
        })
      );
    }
  };

  // The flag is locked once a post is published, but a reused post is still a
  // new post, so it stays editable there.
  const isDisabled =
    Boolean(hasBeenPublished) && !lomavisCreatorConfig?.importing_post;

  return (
    <CreatorCard>
      <div
        onClick={() => {
          if (!isDisabled) handleToggle();
        }}
        className={`d-flex justify-content-between align-items-center ${
          isDisabled ? '' : 'cursor-pointer'
        }`}
      >
        <div className="d-flex align-items-start flex-grow-1 min-w-0">
          <i
            className={`me-3 mt-1 fa-duotone fa-sparkles fs-4 ${
              aiGeneratedContent ? 'text-primary' : 'text-gray-500'
            }`}
          />
          <div className="d-flex flex-column">
            <span className="fw-bold text-dark">{title}</span>
            <span className="fs-7 text-muted">
              {subtitle}{' '}
              <a
                className="text-primary fw-semibold text-nowrap"
                href="https://help.lomavis.com/de/articles/908-ki-generierte-inhalte-kennzeichnen"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {rulesLinkLabel} <span aria-hidden="true">→</span>
              </a>
            </span>
          </div>
        </div>
        <Form.Check
          type="switch"
          id="ai-generated-content-switch"
          aria-label={title}
          checked={Boolean(aiGeneratedContent)}
          disabled={isDisabled}
          onChange={handleToggle}
          onClick={(e) => e.stopPropagation()}
          className="ms-3 mb-0"
        />
      </div>
    </CreatorCard>
  );
};

export default AiGeneratedContentToggle;
